/* eslint-disable */
import { $themeConfig } from '@themeConfig'

export default {
    namespaced: true,
    state: {
        dragAvailable: false,
    },
    getters: {},
    mutations: {
        dragAvailable(state, val) {
            state.dragAvailable = val
        },
    },
    actions: {},
}